Ext.define('SA.HistogramLegendBinSizeControl', {
    alias: 'widget.histogram-legend-bin-size-control',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-histogram-legend-bin-size-control',

    items: [
        {
            xtype: 'number-field-2',
            cls: 'sa-histogram-legend-bin-size-control-number-field'
        }, {
            xtype: 'component',
            cls: 'sa-histogram-legend-bin-size-control-reset-link',
            html: '(Reset)',
            itemId: 'resetLink',

            autoEl: {
                href: '#',
                tag: 'a'
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.field = this.down('number-field-2');
        this.resetLink = this.down('#resetLink');
    },

    initEvents() {
        this.callParent();

        this.field.on('change', this.onChangeField, this);
        this.resetLink.el.on('click', this.onClickReset, this, {preventDefault: true});
    },

    onChangeField() {
        var size = this.field.getValue(),
            truncateToTwoDecimals = value => Math.trunc(value * 100) / 100;

        if (!Ext.isNumeric(size)) {
            size = this.lastSize;
        }
        else {
            size = Math.abs(size);
            size = this.supportsFractions ? truncateToTwoDecimals(size) : Math.trunc(size);
            size = size > 0 ? size : this.lastSize;
        }

        this.lastSize = size;
        this.field.setValue(size); 

        if (size !== this.lastStateSize) {
            this.fireEvent('change', size);
        }
    },

    onClickReset() {
        this.fireEvent('change', null);
    },

    setState({supportsFractions, size, hasCustomSize}) {
        this.supportsFractions = supportsFractions;
        this.lastSize = size;
        this.lastStateSize = size;

        this.resetLink.ifCls(hasCustomSize, 'sa-histogram-legend-bin-size-control-reset-link-enabled');
        this.resetLink.ifCls(!hasCustomSize, 'sa-histogram-legend-bin-size-control-reset-link-disabled');

        this.field.setValue(size);
    }
});